import { SlideFrame } from '../SlideFrame';

const TERMS: [string, string][] = [
  ['Structure', 'L.P.'], ['Mgmt Fee', '1.5%'], ['Perf Fee', '20% over hurdle'],
  ['Hurdle', 'Zero'], ['Lock-up', 'N/A'], ['Liquidity', 'Monthly subscription and redemption'],
  ['Audit', 'MNP'], ['Fund Accounting', 'SGGG'], ['Prime Broker', 'Goldman Sachs'],
  ['Legal', 'Borden Ladner Gervais LLP'],
];

export function Slide18FundTerms() {
  return (
    <SlideFrame pageNum={21} title="FUND TERMS  &  CONTACT" banner="Simple terms. Aligned interests. One call to get started.">
      <div className="grid grid-cols-2 gap-5 h-full items-stretch pt-2 pb-8">
        <div className="bg-[#1e293b] rounded-2xl p-5">
          <div className="text-[#c9a84c] text-[18px] font-bold tracking-wider mb-3">FUND TERMS</div>
          <div className="space-y-1.5 text-[15px]">
            {TERMS.map(([label, value]) => (
              <div key={label} className="flex justify-between border-b border-[#0a0e14]/40 pb-1">
                <span className="text-[#cbd5e1]">{label}</span>
                <span className="text-white">{value}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-[#1e293b] rounded-2xl p-5">
          <div className="text-[#c9a84c] text-[18px] font-bold tracking-wider mb-3">CONTACT</div>
          <div className="text-white text-[21px] font-bold mb-1">Steven Tuchner</div>
          <div className="text-[#cbd5e1] italic text-[15px] mb-3">Founder &amp; CIO</div>
          <div className="text-[#cbd5e1] text-[17px]">info@triumphasset.com</div>
          <div className="text-[#cbd5e1] text-[17px]">www.triumphasset.com</div>
          <div className="text-[#cbd5e1] text-[17px] mb-3">416-366-1947</div>
          <div className="text-[#94a3b8] text-[14px] mt-auto">1806 - 2 Bloor Street West</div>
          <div className="text-[#94a3b8] text-[14px]">Toronto, ON M4W 3E2</div>
        </div>
      </div>
    </SlideFrame>
  );
}
